import './style.scss'

import React, { useEffect, useState } from 'react'

import DefaultDesktopHero from '../../heros/DefaultDesktopHero'
import DefaultMobileHero from '../../heros/DefaultMobileHero'
import DefaultTabletHero from '../../heros/DefaultTabletHero'
import FansFlagsDesktopHero from '../../heros/FansFlagsDesktopHero'
import FansFlagsMobileHero from '../../heros/FansFlagsMobileHero'
import FansFlagsTabletHero from '../../heros/FansFlagsTabletHero'
import SoccerBallDesktopHero from '../../heros/SoccerBallDesktopHero'
import SoccerBallMobileHero from '../../heros/SoccerBallMobileHero'
import SoccerBallTabletHero from '../../heros/SoccerBallTabletHero'
import StadiumDesktopHero from '../../heros/StadiumDesktopHero'
import StadiumMobileHero from '../../heros/StadiumMobileHero'
import StadiumTabletHero from '../../heros/StadiumTabletHero'
import StarsDesktopHero from '../../heros/StarsDesktopHero'
import StarsMobileHero from '../../heros/StarsMobileHero'
import StarsTabletHero from '../../heros/StarsTabletHero'
import t from '../../helpers/i18n'

const HEROS = {
  'default': {
    desktopComponent: DefaultDesktopHero,
    tabletComponent: DefaultTabletHero,
    mobileComponent: DefaultMobileHero
  },
  'stadium': {
    desktopComponent: StadiumDesktopHero,
    tabletComponent: StadiumTabletHero,
    mobileComponent: StadiumMobileHero
  },
  'stars': {
    desktopComponent: StarsDesktopHero,
    tabletComponent: StarsTabletHero,
    mobileComponent: StarsMobileHero
  },
  'flags': {
    desktopComponent: FansFlagsDesktopHero,
    tabletComponent: FansFlagsTabletHero,
    mobileComponent: FansFlagsMobileHero
  },
  'soccer-ball': {
    desktopComponent: SoccerBallDesktopHero,
    tabletComponent: SoccerBallTabletHero,
    mobileComponent: SoccerBallMobileHero
  }
}

const HeroPreview = ({
  heroName,
  backgroundA,
  backgroundB,
  backgroundC,
  colorA,
  colorB,
  colorC
}) => {
  const [heroDesktop, setHeroDesktop] = useState()
  const [heroTablet, setHeroTablet] = useState()
  const [heroMobile, setHeroMobile] = useState()

  useEffect(() => {
    if (heroName && HEROS[heroName]) {
      const Desktop = HEROS[heroName].desktopComponent
      const Tablet = HEROS[heroName].tabletComponent
      const Mobile = HEROS[heroName].mobileComponent
      setHeroDesktop(
        <Desktop
          backgroundA={backgroundA}
          backgroundB={backgroundB}
          backgroundC={backgroundC}
          colorA={colorA}
          colorB={colorB}
          colorC={colorC}
        />
      )
      setHeroTablet(
        <Tablet
          backgroundA={backgroundA}
          backgroundB={backgroundB}
          backgroundC={backgroundC}
          colorA={colorA}
          colorB={colorB}
          colorC={colorC}
        />
      )
      setHeroMobile(
        <Mobile
          backgroundA={backgroundA}
          backgroundB={backgroundB}
          backgroundC={backgroundC}
          colorA={colorA}
          colorB={colorB}
          colorC={colorC}
        />
      )
    }
  }, [heroName, backgroundA, backgroundB, backgroundC, colorA, colorB, colorC])

  return (
    <div className="hero-preview">
      <div className="-desktop">
        <label className="text-label">{t('Desktop')}</label>
        {heroDesktop}
      </div>
      <div className="-non-desktop">
        <div className="-tablet">
          <label className="text-label">{t('Tablet')}</label>
          {heroTablet}
        </div>
        <div className="-mobile">
          <label className="text-label">{t('Mobile')}</label>
          {heroMobile}
        </div>
      </div>
    </div>
  )
}

export default HeroPreview
